import React, { createContext, useContext, useMemo } from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { useConfig } from './ConfigContext';

const DynamicThemeProvider = ({ children }) => {
  const { getBrandingConfig, brandingReady } = useConfig();
  const branding = getBrandingConfig();

  // Rebuild only when the branding object changes (cache on first paint, then the live config)
  const theme = useMemo(() => {
    return createTheme({
      palette: {
        primary: {
          main: branding.primaryColor || '#1976d2',
        },
        secondary: {
          main: branding.secondaryColor || '#dc004e',
        },
        // Add custom branding palette
        branding: {
          primary: branding.primaryColor || '#1976d2',
          secondary: branding.secondaryColor || '#dc004e',
          logo: branding.logo || '/assets/logo.png',
          favicon: branding.favicon || '/assets/favicon.ico',
          companyName: branding.companyName || 'UCENA Management System',
          tagline: branding.tagline || 'Streamline Your Business Operations'
        }
      },
      // Add branding to theme
      branding: {
        companyName: branding.companyName || 'UCENA Management System',
        tagline: branding.tagline || 'Streamline Your Business Operations',
        logo: branding.logo || '/assets/logo.png',
        favicon: branding.favicon || '/assets/favicon.ico',
        primaryColor: branding.primaryColor || '#1976d2',
        secondaryColor: branding.secondaryColor || '#dc004e'
      },
      components: {
        // Customize component styles based on branding
        MuiAppBar: {
          styleOverrides: {
            root: {
              backgroundColor: branding.primaryColor || '#1976d2',
            },
          },
        },
        MuiButton: {
          styleOverrides: {
            contained: {
              backgroundColor: branding.primaryColor || '#1976d2',
              '&:hover': {
                backgroundColor: branding.primaryColor ? 
                  `${branding.primaryColor}dd` : '#1565c0',
              },
            },
          },
        },
        MuiChip: {
          styleOverrides: {
            colorPrimary: {
              backgroundColor: branding.primaryColor || '#1976d2',
            },
          },
        },
      },
    });
  }, [branding]);

  // No cached branding yet (first visit on this browser): keep MUI defaults until config loads
  if (!brandingReady) {
    return children;
  }

  return (
    <ThemeProvider theme={theme}>
      {children}
    </ThemeProvider>
  );
};

export default DynamicThemeProvider; 